import { EmailRecipient } from './email-recipient';
import { EmailSender } from './email-sender';

export class EMailFileDetails {
  public fileName?: string;
  public fileContentType?: string;
  public fileExtension?: string;
  public fileSize: number; // Gets the file size in bytes.

  public id?: string; // The ID of the message when the MSG file has been sent across the internet (as specified in [RFC2822]). Null when not available

  public subject?: string; // The subject of the message object
  public sentOnUtcDateTime?: string; // The date/time in UTC format when the public message object has been sent, null when not available
  public sender: EmailSender;
  public recipients?: EmailRecipient[]; // The list of recipients in the message object
  public bodyText?: string; // The truncated body of the Outlook message in public plain text format. The max length is 1024 characters.
  public bodyHtml?: string; // The body of the Outlook message in HTML format.
  public bodyRtf?: string; // The body of the Outlook message in RTF format.

  constructor(data) {
    Object.assign(this, data);
  }
}

export interface EmailFileDetailsDTO {
  fileName: string;
  fileContentType: string;
  fileExtension: string;
  id: string;
  subject: string;
  sentOnUtcDateTime: string;
  sender: EmailSender;
  recipients: {
    email: string;
    displayName: string;
    type: string;
    addressType: string;
  }[];
  attachments: [
    {
      filename: string;
      extention: string;
    },
  ];
  bodyText: string;
  bodyHtml: string;
  bodyRtf: string;
}
